import { IntrinsicSizeImg } from 'components/Img';
import Text from 'components/Text';
import { filterTruthy } from 'utils/collection';
import { cleanAltText } from 'utils/string';

interface Image {
	alt?: string;
	src: string;
}

interface Props {
	className?: string;
	heading?: string;
	images: Image[] | undefined;
}

/** Payment method logos. */
export default function PaymentMethodLogos({
	className,
	heading,
	images,
}: Props) {
	const filteredImages = filterTruthy(images, 'src').map((img) => ({
		...img,
		alt: cleanAltText(img.alt),
	}));

	if (!filteredImages?.length) {
		return null;
	}

	const altCount = filteredImages.filter((img) => img.alt).length;

	return (
		<div className={className}>
			{heading && (
				<Text as="p" className="mb-2 font-bold">
					{heading}
				</Text>
			)}
			<ul className="flex flex-wrap gap-3" aria-hidden={altCount === 0}>
				{filteredImages.map(({ alt, src }) => (
					<li key={src} aria-hidden={!alt}>
						<IntrinsicSizeImg
							loading="eager"
							className="h-6 max-w-20"
							src={src}
							alt={cleanAltText(alt)}
						/>
					</li>
				))}
			</ul>
		</div>
	);
}
PaymentMethodLogos.displayName = 'PaymentMethods';
